import { isElementNode, isTag } from 'anodum';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';

const isMediaContainer = (element) => {
  if (!isElementNode(element)) return false;

  return isTag(element, IMAGE_SELECTOR);
};

export default isMediaContainer;
